export enum NewsType {
  WARNING = 'warning',
  INFO = 'info',
  PRIMARY = 'primary',
}

export interface News {
  [key: string]: { text: string; link: string; type: NewsType; id: number; linkText?: string }
}
